import { forwardRef, type ReactNode } from "react";

import clsx from "clsx";

import { InputButton, type InputButtonProps } from "../input-button";

interface Props extends InputButtonProps {
  value?: string;
  placeholder?: ReactNode;
  hideCaret?: boolean;
  onClear?: () => void;
}

export const SelectButton = forwardRef<HTMLButtonElement, Props>(
  ({ value, placeholder, className, hideCaret, onClear, ...props }, ref) => {
    return (
      <InputButton
        ref={ref}
        className={clsx(className, {
          "text-v2-secondary focus:text-v2-secondary": !value,
        })}
        rightIcon={
          <>
            {onClear && value && (
              <i
                className={clsx(
                  "fa-regular fa-times-circle text-sm text-v2-cosmic/400 cursor-pointer",
                  "hover:text-v2-cosmic/600 group-data-[disabled]:text-v2-gray/200",
                )}
                onClick={(e) => {
                  e.stopPropagation();
                  onClear();
                }}
              />
            )}
            {!hideCaret && (!onClear || !value) && (
              <i
                className={clsx(
                  "fa-regular fa-angle-down text-base text-v2-primary",
                  "group-data-[open]:text-v2-action group-data-[open]:rotate-180",
                  "group-data-[disabled]:text-v2-secondary",
                  "transition-[transform] duration-200 ease-out",
                )}
              />
            )}
          </>
        }
        {...props}
      >
        {value ?? placeholder ?? "Select.."}
      </InputButton>
    );
  },
);
